import React, { Fragment, useCallback, useEffect, useRef, useState } from "react"
import { FaChevronDown } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import LandingCategoryDropdownItem from "./FoodCategoryDropdownItem"
import classes from "./FoodCategoriesChipChevron.module.scss"

const FoodCategoriesChipChevron = props => {
  const { chipRef, category, handleChangeFilter } = props
  
  const i18n = useTranslation()[1]

  const [openDropdown, setOpenDropdown] = useState(false)
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 })

  const chevronRef = useRef(null)
  const dropdownRef = useRef(null)

  const handleClickOutside =
    useCallback((e) => {
      if (chevronRef.current?.contains(e.target)) return
      if (dropdownRef.current?.contains(e.target)) return

      setOpenDropdown(false)
    }, [])

  const handleOpenDropdown = (e) => {
    e.stopPropagation()

    setOpenDropdown(prev => !prev)

    const dropdownWidth = 220

    const dropdownRight =
      window.innerWidth -
      (chevronRef.current.getBoundingClientRect().right + dropdownWidth)

    const offsetRight = Math.min(dropdownRight, 0)

    const dropdownLeft =
      Math.max(
        chevronRef.current.getBoundingClientRect().left, 0
      )

    const left = dropdownLeft + offsetRight

    const top =
      chipRef.current.offsetHeight + 5

    setDropdownPosition({ top, left })
  }

  useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside)
    window.addEventListener("touchstart", handleClickOutside)

    return () => {
      window.removeEventListener("mousedown", handleClickOutside)
      window.removeEventListener("touchstart", handleClickOutside)
    }
  }, [])

  const dir = i18n.dir(i18n.language)

  const isLtr = dir === "ltr"

  return (
    <Fragment>
      <button
        ref={chevronRef}
        onClick={handleOpenDropdown}
        className={clsx(classes["chevorn"], isLtr && classes["chevorn-ltr"])}
      >
        <FaChevronDown size={15} />
      </button>

      {
        openDropdown &&
        <div
          ref={dropdownRef}
          className={classes["dropdown-container"]}
          style={{
            top: `${dropdownPosition.top}px`,
            left: `${dropdownPosition.left}px`
          }}
        >
          {category.children.map(c =>
            <LandingCategoryDropdownItem
              key={c._id}
              category={c}
              setOpenDropdown={setOpenDropdown}
              onSelect={handleChangeFilter}
            />
          )}
        </div>
      }
    </Fragment>
  )
}

export default FoodCategoriesChipChevron